import { memo } from "react";
import { redirectToUrl } from "~/utils/url/urlUtils";
import ToastMessage from "~/common/components/Messages/ToastMessage/ToastMessage";
import { useTranslation } from "react-i18next";
import { Button, Card, Stack, styled, Typography } from "~/common/mui";
import { C_PRIMARY_CONTAINER } from "~/common/components/icon/Colors";
import { IMG_LINK_EXPIRED } from "~/utils/url/staticResources";

interface Props {
  errors: string[];
}

const ExpiredLinkPage = ({ errors }: Props) => {
  const { t } = useTranslation();

  return (
    <StyledCard>
      {errors.map((err) => (
        <ToastMessage type={"error"} key={err}>
          {t(err)}
        </ToastMessage>
      ))}
      <IconContainer>
        <Icon src={IMG_LINK_EXPIRED} alt={t("page.expiredLink.iconAlt")} />
      </IconContainer>
      <Stack gap={3}>
        <Typography variant="headlineMedium" textAlign={"center"}>
          {t("page.expiredLink.title")}
        </Typography>
        <Stack gap={1}>
          <Typography variant="bodyLarge" textAlign={"center"}>
            {t("page.expiredLink.subtitle.one")}
          </Typography>
          <Typography variant="bodyLarge" textAlign={"center"}>
            {t("page.expiredLink.subtitle.two")}
          </Typography>
        </Stack>
        <Button
          variant="text"
          data-test-id={"expired-registration-button"}
          onClick={() => redirectToUrl("/registered/user")}
        >
          {t("page.expiredLink.signup")}
        </Button>
      </Stack>
    </StyledCard>
  );
};

export default memo(ExpiredLinkPage);

const StyledCard = styled(Card)({
  display: "flex",
  width: "386px",
  padding: "24px",
  flexDirection: "column",
  margin: "64px auto",
  alignItems: "center",
  gap: "32px",
});

const IconContainer = styled("div")({
  display: "flex",
  padding: "12px",
  alignItems: "center",
  gap: "8px",
  borderRadius: "50%",
  backgroundColor: C_PRIMARY_CONTAINER,
});

const Icon = styled("img")({
  height: "40px",
  width: "40px",
});
